import { memo } from 'react';
import { Handle, NodeResizer, Position, NodeProps } from '@xyflow/react';

import { getVariableDefinitions } from '@/explore/utils';
import { useExplorationContext } from '@/explore/exploration/exploration-context';
import { useExplorationUIContext } from '@/explore/exploration/exploration-ui-context';

import { getExplorationCellIndex } from '@/core/exploration';

import { ExplorationCell } from '../../exploration/exploration-cell';

import canvasStyles from './canvas.module.scss';

const CanvasCardNode = ({ selected = false, height, width, id, zIndex }: NodeProps) => {
  const { exploration, parameters, getCellById } = useExplorationContext();
  const { openEditor } = useExplorationUIContext();
  const cell = getCellById(id);

  if (!cell) {
    return null;
  }

  return (
    <>
      <NodeResizer isVisible={selected} minWidth={100} minHeight={100} />
      <Handle type="source" id="top" position={Position.Top} isConnectable />
      <Handle type="source" id="left" position={Position.Left} isConnectable />
      <ExplorationCell
        className={canvasStyles.canvasItem}
        index={getExplorationCellIndex(exploration, cell.id)}
        cell={cell}
        variables={getVariableDefinitions(exploration)}
        isCollapsible={false}
        isResizable={false}
        selected={selected}
        parameters={parameters}
        height={height}
        onSelectCell={() => openEditor(cell.id)}
        canvasView
        style={{ height, width, zIndex }}
      />
      <Handle type="source" id="bottom" position={Position.Bottom} isConnectable />
      <Handle type="source" id="right" position={Position.Right} isConnectable />
    </>
  );
};

export default memo(CanvasCardNode);
